import errorRender from "./errorRender";
import defaultRender from "./defaultRender";
import Formatter from "../formatter";
export default function timestampRender(cellData, item) {
  if (!cellData) {
    return '';
  }
  if (isNaN(Number(cellData))) {
    return errorRender();
  }
  var timeFormatter = item.timeFormatter;
  var result = Formatter.date(cellData, timeFormatter);
  return defaultRender(result);
}